type Error = { countLast90Days: number; severity: number; detection: number };

/**
 * Calculate occurrence rating based on frequency in last 90 days
 * 1-2: Rare (1-2 occurrences)
 * 3-4: Unlikely (3-5 occurrences)
 * 5-6: Occasional (6-10 occurrences)
 * 7-8: Likely (11-20 occurrences)
 * 9-10: Frequent (21+ occurrences)
 */
export function calculateOccurrenceRating(count90Days: number): number {
  if (count90Days <= 2) return 1;
  if (count90Days <= 5) return 3;
  if (count90Days <= 10) return 5;
  if (count90Days <= 20) return 7;
  return 9;
}

/**
 * Get occurrence rating label
 */
export function getOccurrenceLabel(rating: number): string {
  if (rating <= 2) return "Rare";
  if (rating <= 4) return "Unlikely";
  if (rating <= 6) return "Occasional";
  if (rating <= 8) return "Likely";
  return "Frequent";
}

/**
 * Calculate RPN: Risk Priority Number = Severity × Occurrence × Detection
 * Range: 1-1000
 */
export function calculateRPN(
  severity: number,
  occurrence: number,
  detection: number,
): number {
  return severity * occurrence * detection;
}

/**
 * Get RPN risk level and color
 */
export function getRPNRiskLevel(rpn: number): {
  level: "low" | "medium" | "high";
  color: string;
  label: string;
} {
  if (rpn <= 100) {
    return { level: "low", color: "green", label: "Low Risk" };
  }
  if (rpn <= 500) {
    return { level: "medium", color: "yellow", label: "Medium Risk" };
  }
  return { level: "high", color: "red", label: "High Risk" };
}

/**
 * Recalculate RPN for an error
 */
export function recalculateErrorRPN(error: Error): number {
  const occurrence = calculateOccurrenceRating(error.countLast90Days);
  return calculateRPN(error.severity, occurrence, error.detection);
}
